import React from 'react';
import styled from 'styled-components';

// constants
import { variants, sizes } from './style';

export interface SquareProps {
  size?: keyof typeof sizes;
  flexShrink?: number;
  variant?: keyof typeof variants;
  className?: string;
  active?: boolean;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

const defaultSize = 'sm';

const StyledSquare = styled.div.withConfig({
  shouldForwardProp: prop => !['variant', 'size', 'flexShrink', 'paddingLeft'].includes(prop),
})<SquareProps>`
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => sizes[props.size || defaultSize]};
  height: ${props => sizes[props.size || defaultSize]};
  ${props => variants[props.variant || 'action']};
  flex-shrink: ${props => props.flexShrink || 0};
`;

const Square = (props: SquareProps) => {
  return <StyledSquare {...props} />;
};

export default Square;
